import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { getPaymentOptions, PaymentOptionType as PaymentGateway, } from '@debbie/common/dist/collectors';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors';
import { PlaceholderLoader } from '..';
import THEME from '../../theme';
import PaymentOption from './PaymentOption';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers';
import { h } from '@debbie/cortex/dist';
import { defaultPaymentPlansConfig } from '@debbie/common/dist/economy/payment-plans';
import { useCreditor } from '@debbie/cortex/dist/creditors';
const Pay = (props) => {
    const { collector, isPaymentPlan, case: singleCase } = props;
    if (!singleCase)
        return null;
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const creditorLoadable = useCreditor(singleCase === null || singleCase === void 0 ? void 0 : singleCase.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const plans = (creditor === null || creditor === void 0 ? void 0 : creditor.paymentPlansConfig) ||
        (tenant === null || tenant === void 0 ? void 0 : tenant.paymentPlansConfig) ||
        defaultPaymentPlansConfig;
    const showPaymentPlans = plans.plans.length > 0;
    const caseVouchers_ = useCaseVouchersByCase(props.case.caseId);
    const caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const paymentOptions = collector &&
        collector.paymentOptions &&
        singleCase &&
        getPaymentOptions(collector.paymentOptions, singleCase.currency).filter((option) => {
            if ([PaymentGateway.REEPAY, PaymentGateway.FARPAY].includes(option.type)) {
                return option.isActive;
            }
            return true;
        });
    return (React.createElement("div", null,
        React.createElement(PaymentPanel, null,
            React.createElement("h3", { className: "header" }, lang.debtorWebHome.paymentMethods),
            paymentOptions && caseVouchers ? (React.createElement(React.Fragment, null,
                React.createElement("div", null, props.children),
                paymentOptions
                    .filter((p) => !p.hideOnDebtorweb)
                    .map((paymentOption, index) => (React.createElement(PaymentOption, { key: index, paymentOption: paymentOption, case: singleCase, collector: collector, caseVouchers: caseVouchers, isPaymentPlan: isPaymentPlan, paymentOptionsCount: paymentOptions ? paymentOptions.length : 0 }))))) : (React.createElement(PlaceholderLoader, null))),
        !isPaymentPlan && showPaymentPlans && (React.createElement(SubPaymentMethod, { className: "ui-test-3ba49359", to: `/cases/${singleCase.id}/payment-plan` },
            React.createElement("p", null, lang.debtorWebHome.createAPaymentPlan)))));
};
export default Pay;
const SubPaymentMethod = styled(Link) `
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  color: grey;
  font-weight: 700;
  font-size: 0.9em;
`;
const PaymentPanel = styled.div `
  padding: 0px ${THEME.GRID_SPACING * 3}px ${THEME.GRID_SPACING}px;
  background-color: ${(props) => props.secondary ? THEME.COLOR_PRIMARY : THEME.COLOR_SECONDARY};
  color: ${(props) => props.secondary ? THEME.COLOR_SECONDARY : THEME.COLOR_PRIMARY};
  border-radius: 5px;
  box-shadow: 0 20px 70px -30px rgba(0, 0, 0, 0.15);

  .providers {
    padding: ${THEME.GRID_SPACING}px 0;
    text-align: center;

    img {
      max-width: 80%;
      max-height: 20px;
    }
  }

  .header {
    border-bottom: 1px solid ${THEME.DARK_COLOR_SECONDARY};
    text-align: center;
    padding: ${THEME.GRID_SPACING}px;
    margin: 1em -${THEME.GRID_SPACING * 3}px;
    text-transform: uppercase;
    font-size: 1.1em;
    background-color: ${THEME.COLOR_SECONDARY};
  }
`;
//# sourceMappingURL=Pay.js.map